import MobileModal, { type MobileModalProps } from "@/components/mobile-modal";
import SearchForm, { type SearchFormProps } from "@/components/search-form";

export interface MobileSearchModalProps extends MobileModalProps {
  searchFormProps?: SearchFormProps;
}

export default function MobileSearchModal({
  searchFormProps = {},
  ...props
}: MobileSearchModalProps) {
  return (
    <MobileModal {...props} closeButton="right">
      <SearchForm
        onSubmit={() => props.onOpenChange?.(false)}
        {...searchFormProps}
      />
    </MobileModal>
  );
}
